<template lang="html">
  <v-flex class="md4 xs12 order-list">
    <v-container ma-0 pa-3 fluid class="card-container" d-flex style="flex-direction: column">
      <v-layout row>
        <v-flex>
          <strong class="fs-18 ">
            Pedido ref.:   
          </strong>               
          <span class="fs-18 titulo-detalhes "> {{ value.identifier}} </span>
        </v-flex>
        <v-flex class="text-xs-right mt-2">
          {{ value.date | calendar }}
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex class="order-color">
          {{ value.condominium.name }}<br>
          Cliente: {{ value.client }}<br>
          Unidade: {{ value.unit }}<br>
        </v-flex>
      </v-layout>
      <v-layout row mb-2 mt-2>
        <v-flex class="order-color">
          <strong>Itens Pedidos</strong><br>
          <template lang="html" v-for="item in value.itens">           
            <span>
              {{ item.name }};
            </span>
          </template>
        </v-flex>
      </v-layout>
      <v-layout row align-end>
        <v-flex>
          <div class="fs-18 mt-1">
            <strong>Valor total</strong>: {{ price | currency }}
          </div>
        </v-flex>
        <v-flex class="text-xs-right">
          <v-btn class="elevation-0 order-details-btn ma-0" v-on:click="orderDetails(value.id)">+ detalhes</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-flex>
</template>

<script>
import moment from 'moment'
import 'moment/locale/pt-br'
export default {
  props: ['value'],
  methods: {
    orderDetails (id) {
      this.$store.dispatch('selectOrder', id)
    }
  },
  computed: {
    price () {
      // return this.value.itens.reduce((prevVal, elem) => {
      //   return prevVal + (elem.price * elem.count)
      // }, this.value.price)
      return this.value.itens.reduce((prevVal, elem) => prevVal + (elem.count * elem.price), 0)
    }
  },
  filters: {
    currency (value) {
      if (typeof value !== 'number') return ''
      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    calendar (value) {
      // debugger
      moment.locale('pt-br')
      return moment(value).calendar(null, {
        sameDay: '[Hoje às] h:mm a',
        nextDay: '[Tomorrow] h:mm a',
        nextWeek: '[Próxima] dddd',
        lastDay: '[Ontem às] h:mm a',
        lastWeek: 'dddd [passada]',
        sameElse: 'DD MMM [às] h:mm a'
      })
      // return moment(value).format('LLL')
    }
  }
}
</script>

<style>
.card-container {
  height: 100%;
}
.order-list{
  padding: 10px;
}
.order-list>div{
  border-radius: 10px;
  border: 1px solid #8e8e8e;
}
.fs-18{
  font-size: 18px;
}
.new{
  color: red!important;
}
.order-details-btn div{
  background: #0264c7;
  padding: 5px 10px;
  float: left;
  color: #fff;
  cursor: pointer;
}
.order-status::after{
  content: ' ';
  display: block;
  height: calc(100% - 40px);
  border-left: 1px solid #c7c7c7;
  width: 1px;
  margin: auto;
  margin-top: 10px;
}
.order-color{
  color:#767676
}
.list .order-status{
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// order.vue?6274b3c0